import { fetchPost, fetchPut, fetchGet } from '@/utils/request'

export function getTelephoneNoraml (query) {
    return fetchGet('/gateway/v1/telephones/all', query)
}

export function getTelephoneForBind (query) {
    query['frozen_status'] = 1;
    return fetchGet('/gateway/v1/telephones/frozen', query)
}

export function editTelephoneStatus(customerId,id,query) {
    return fetchPut('/gateway/v1/customer-hotline/'+customerId+'/telephone/'+id+'/status', query)
}

export function editTelephoneUnFrozen(id,query) {
    return fetchPut('/gateway/v1/telephones/'+id+'/unfreeze', query)
}

export function editTelephoneUnFrozenIds(query) {
    return fetchPut('/gateway/v1/telephones/unfreeze-ids', query)
}